import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/"
import api from "../../../api";

import { Label, Input, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class SubirDocumento extends Component {
    constructor(props) {
        super(props);
        this.state = {
            observacion: "",
            url: "",
            plan_id: null,
            solicitud_id: null,
            proyecto_codigo: null,
        };
    }



    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            observacion: "",
            url: "",
            plan_id: null,
            solicitud_id: null,
            proyecto_codigo: null,
        })
    }

    setSelects(data) {
        this.setState({
            observacion: data.observacion,
            url: (data.url != undefined ? api.BASE_URL + data.url : ""),
            plan_id: data.pk,
            solicitud_id: data.solicitud_id,
            proyecto_codigo: data.solicitud_codigo,
        });
    }

    render() {
        return (
            <ParadigmaModal
                fileUploader={true}
                getUrl={api.proyectos.plandetrabajo.subirdocumento}
                postUrl={api.proyectos.plandetrabajo.subirdocumento}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Documento ha sido subido con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Subir Documento"}
                buttonTitle={"Subir Documento"}
                buttonIcon={"fa fa-upload fa-lg"}
                className={"ui-modal-dialog ui-modal-md"}
                notAllowedMessage={"El Plan de Trabajo no puede ser editado en esta etapa porque ya fue avanzada."}

                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >
                <div className="ui-form">
                <p className="ui-section-label">Datos del proyecto</p>
                <div className="ui-row-1">
                    <div className="ui-field">
                        <Label>Código</Label>
                        <ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"cod"} fieldName={""} url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
                <div className="ui-row-1">
                    <div className="ui-field">
                        <Label>Proyecto</Label>
                        <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} value={this.state.solicitud_id} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>

                <Input type="hidden" value={(this.state.plan_id ? this.state.plan_id : "")} onChange={(e) => { return; }} />
                <div className="ui-divider"></div>
                <div className="ui-row-1">
                    {this.state.url != "" &&
                        <div className="ui-field">
                            <a target={"_blank"} href={this.state.url}>DESCARGAR DOCUMENTO</a>
                        </div>
                    }
                    <div className="ui-field">
                        <Label>Archivo{this.state.url && <i className="pl-4">El documento subido puede ser reemplazado.</i>}</Label>
                        <Input type="file" name="file"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
                <div className="ui-row-1">
                    <div className="ui-field">
                        <Label>Observaciones</Label>
                        <Input type="textarea" name="observacion" value={this.state.observacion} onChange={(e) => this.setState({ observacion: e.target.value })} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default SubirDocumento;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento2/SubirDocumento.js